import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { LanguageId } from '@interfaces';
import { AppService } from '../../../../../../services';
import { SessionTopicAssignmentByEvent } from '../session-assignments.part';


export function getColumns(util: UtilityService, app: AppService) {
	const columns: GridColumn<SessionTopicAssignmentByEvent, unknown>[] = [
		buildColumn(util, 'Id', row => row.topicId, { header: 'TopicId' }),
		buildColumn(util, 'Text', row => row.languageId === LanguageId.English ? 'English' : 'Spanish', { header: 'Language' }),
		buildColumn(util, 'FullName', row => row.topicName, { header: 'Topic', group: 'asc' }),
		buildColumn(util, 'Id', row => row.accId, { header: 'AccId' }),
		buildColumn(util, 'Id', row => row.eventId, { header: 'EventId' }),
		buildColumn(util, 'FullName', row => app.getStaffNameById(row.facilitatorStaffId), { header: 'Program Facilitator' }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.startUTC), { header: 'Event Start' }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.endUTC), { header: 'Event End' }),
		buildColumn(util, 'FullName', row => row.assignedSpecialistNames.join(', '), { header: 'Assigned Specialist(s)' }),
		buildColumn(util, 'Number', row => row.countOfSurveys, { header: '# Surveys' }),
		buildColumn(util, 'Number', row => row.pendingSignups, { header: 'Pending Sign-ups' }),
		buildColumn(util, 'Number', row => row.waitlistedSignups, { header: 'Waitlisted Sign-ups' }),
	];

	return columns;

}
